"use client";
import { ISession } from "@/models";
import { useAppDispatch, useAppSelector } from "@/redux-store";
import { authActions } from "@/redux-store/auth.slice";

const useSession = () => {
  const dispatch = useAppDispatch();
  const session = useAppSelector((state) => state.authReducer.session);
  const setSession = (newValue?: ISession) => {
    dispatch(authActions.setSession(newValue));
  };
  return { setSession, session };
};

export default useSession;
